export enum CounterpartyDocumentSelectFields {
    vendor = "vendor",
    vendorAddress = "vendorAddress",
    vendorSite = "vendorSite",
    vendorBankName = "vendorBankName",
    vendorBic = "vendorBic",
    vendorPaymentAccount = "vendorPaymentAccount",
    vendorCorrAccount = "vendorCorrAccount"
}
